var order_info_fields = {
  "date_created": "Дата создания",
  "date_updated": "Дата обновления",
  "amount": "Сумма",
  "merchant_id": "Мерчант",
  "terminal_id": "Терминал",
  "split_terminal_id": "Терминал контрагента",
  "currency_code": "Валюта",
  "merchant_order_id": "№ заказа продавца",
  "map_order_id": "№ заказа MAP",
  "processing_id": "Процессинг",
  "state_id": "Статус",
  "processing_state_id": "Статус процессинга",
  "processing_error_code": "Причина отказа",
  "processing_message": "Отказ эквайера",
  "pan_mask": "Номер карты",
  "card_holder": "Владелец карты",
  "ip": "IP",
  "ip_continent": "Континент",
  "ip_stateprov": "Регион",
  "ip_district": "Район",
  "ip_city": "Населенный пункт",
  "ip_zipcode": "Индекс",
  "ip_latitude": "Широта",
  "ip_longitude": "Долгота",
  "ip_geoname_id": "ID геолокации",
  "ip_timezone_offset": "Часовой пояс",
  "ip_timezone_name": "Имя часового пояса",
  "ip_weather_code": "Код метеостанции",
  "country_code": "Код страны",
  "card_type_name": "Карта",
  "bank_name": "Эмитент",
  "description": "Описание",
  "custom_params": "Параматры",
  "auth_code": "Код авторизации",
  "rrn": "RRN",
  "antifraud_decision": "Решение АФ",
  "bank_country_code": "Страна эмитента",
  "ip_country_code": "Страна IP",
  "is_recurrent": "Рекуррент",
  "is_receipt": "С фискализацией",
  "card_type_type": "Тип карты",
  "card_product_type": "Тип продукта",
  "no_cvv": "Без CVV"
}

export default order_info_fields